/**
 * Quote Header Component
 * Sticky header with logo and back navigation
 */
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useFranchise } from "@/context/FranchiseContext";
import { LOGO_URL } from "./constants";

export default function QuoteHeader() {
  const navigate = useNavigate();
  const { franchise, getHomeUrl } = useFranchise();

  return (
    <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <button
            onClick={() => {
              window.scrollTo(0, 0);
              navigate(getHomeUrl());
            }}
            className="flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
            data-testid="back-to-home-btn"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="hidden sm:inline">Back to Home</span>
          </button>
          <div className="flex items-center gap-2">
            <img 
              src={franchise?.logo_url || LOGO_URL} 
              alt={franchise?.name || "Rolling Suds"} 
              className="h-20 w-auto" 
            />
          </div>
          <div className="w-24" />
        </div>
      </div>
    </header>
  );
}
